import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AmbientBackground from './components/AmbientBackground';
import TopBar from './components/TopBar';
import ToastViewport from './components/Toast';
import NovoPedidoDialog from './features/pedidos/NovoPedidoDialog';
import { usePedidosStore } from './features/pedidos/store';
import { useLiveSync } from './features/pedidos/useLiveSync';

export default function App() {
  const carregar = usePedidosStore((s) => s.carregar);
  const location = useLocation();
  const [novoAberto, setNovoAberto] = useState(false);

  useEffect(() => {
    carregar();
  }, [carregar]);

  useLiveSync();

  const rotaFullscreen = location.pathname.startsWith('/rotas');

  if (rotaFullscreen) {
    return (
      <div className="app-shell">
        <Outlet />
        <ToastViewport />
      </div>
    );
  }

  return (
    <div className="app-shell">
      <AmbientBackground petals={5} />
      <TopBar onNovoPedido={() => setNovoAberto(true)} />
      <main className="relative z-[1] w-full px-s7 py-s7">
        <Outlet />
      </main>
      <NovoPedidoDialog aberto={novoAberto} onClose={() => setNovoAberto(false)} />
      <ToastViewport />
    </div>
  );
}
